export enum Source {
    Web = 'Web',
    ClientPortal = 'ClientPortal',
    ContractorPortal = 'ContractorPortal',
    ConnectContractor = 'ConnectContractor',
    Mobile = 'Mobile',
    Import = 'Import',
    Manager = "Manager",
    Field = "Field",
}
